export const articles_image = [
  require('./Article 1 inauguration.png'),
  require('./Article 2 merch.png'),
  require('./Article 3 Ramene ton pote.png'),
];
